import fish1 from '../assets/images/products/fishes/pfish1.png'
import fish2 from '../assets/images/products/fishes/pfish2.png'
import fish3 from '../assets/images/products/fishes/pfish3.png'
import fish4 from '../assets/images/products/fishes/pfish4.png'
import fish5 from '../assets/images/products/fishes/pfish5.png'
import fish6 from '../assets/images/products/fishes/pfish6.png'


export const fishProductsList =
[
    {
        cat:'Frozen fish',
        products:[
            {
                image: fish1,
                subtitle: 'Frozen fish',
                title: 'Frozen Macerel',
                rating: 4.9
            },
            {
                image: fish2,
                subtitle: 'Frozen fish',
                title: 'Horse Mackerel',
                rating: 4.9
            },
            {
                image: fish3,
                subtitle: 'Frozen fish',
                title: 'Silver Smelt',
                rating: 4.7
            },
            {
                image: fish4,
                subtitle: 'Frozen fish',
                title: 'Frozen Herring',
                rating: 4.7
            },
            {
                image: fish5,
                subtitle: 'Frozen fish',
                title: 'Frozen Salmon',
                rating: 4.4
            },
            
        ]
    },
    {
        cat:'Smoked fish',
        products:[ 
            {
                image: fish6,
                subtitle: 'Smoked smelt',
                title: 'Smoked Herring',
                rating: 4.9
            }
        ]
    }
    
]